import React, { useEffect, useRef } from "react";
import "../styles/infoSection.css";
import { UserRound, Clock4, PlaneTakeoff, ShieldCheck } from "lucide-react";

const infoData = [
  {
    icon: UserRound,
    title: "Professional Drivers",
    text: "Friendly, uniformed, and highly trained chauffeurs you can trust.",
  },
  {
    icon: Clock4,
    title: "24/7 Service",
    text: "We’re available day or night — whenever you need a ride.",
  },
  {
    icon: PlaneTakeoff,
    title: "Airport Transfers",
    text: "Reliable pick-up & drop-off service to Colombo International Airport.",
  },
  {
    icon: ShieldCheck,
    title: "Safe & Reliable",
    text: "Your safety is our top priority with every ride we offer.",
  },
];

export default function InfoSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const cards = sectionRef.current?.querySelectorAll(".info-card");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("reveal");
        });
      },
      { threshold: 0.1 }
    );
    cards?.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="info-section" ref={sectionRef}>
      <h2>Why Ride With Lak Derana Cabs?</h2>
      <div className="info-grid">
        {infoData.map(({ icon: Icon, title, text }) => (
          <div className="info-card hidden" key={title}>
            <div className="info-icon">
              <Icon size={36} strokeWidth={2.4} />
            </div>
            <h3>{title}</h3>
            <p>{text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
